/**
 * GET /api/birthdays/ — shared by the Upcoming Birthdays panel and the
 * "Birthdays Today" KPI card. Both mount together on the admin dashboard, so one
 * in-flight request is reused instead of asking the server twice.
 */
import { getAccessToken } from '../../../auth/tokenStore';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/$/, '') || '';
const REUSE_MS = 60 * 1000;

let cached = null; // { at, promise }

export const fetchBirthdays = ({ force = false } = {}) => {
  if (!force && cached && Date.now() - cached.at < REUSE_MS) return cached.promise;
  const promise = axios
    .get(`${API_BASE}/api/birthdays/`, { headers: { Authorization: `Bearer ${getAccessToken()}` } })
    .then((r) => (Array.isArray(r.data?.results) ? r.data.results : []));
  cached = { at: Date.now(), promise };
  // A failed request must not be reused for the next minute.
  promise.catch(() => { if (cached?.promise === promise) cached = null; });
  return promise;
};

// Test-only: forget the shared request.
export const __resetBirthdaysCache = () => { cached = null; };

// "20 Oct" — the year is never shown (the API does not send the birth year).
export const formatBirthdayDate = (iso) => {
  const [y, m, d] = (iso || '').split('-').map(Number);
  if (!y || !m || !d) return '—';
  return new Date(y, m - 1, d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
};

export const whenLabel = (daysUntil) => {
  if (daysUntil === 0) return 'Today';
  if (daysUntil === 1) return 'Tomorrow';
  return `in ${daysUntil} days`;
};
